import React from 'react';
import { styled, Box, Container } from '@goodrx/matisse';

import { Link } from 'react-router-dom';
import AppLogo from 'app/components/AppLogo/AppLogo';
import { Breakpoints } from 'app/config/constants';
import { CoreLink } from 'app/components/core/CoreLink';

const Footer = styled.footer`
  background: ${(p) => p.theme.colors.greyLightest};
  margin-top: 24px;
  padding: 16px 0;
`;

const FooterList = styled.ul`
  display: flex;
  list-style: none;
  padding-left: 0;
  margin: 0;

  li + li {
    margin-left: 1rem;
  }

  a {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.greyDarker};
  }

  .mdi {
    color: ${(props) => props.theme.colors.greyDark};
  }

  @media (max-width: ${Breakpoints.sm}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: ${(p) => p.theme.space[3]}px;
    column-gap: ${(p) => p.theme.space[5]}px;
    margin-top: ${(p) => p.theme.space[4]}px;
  }
`;

const FooterInner = styled(Container)`
  display: flex;
  align-items: center;

  @media (max-width: ${Breakpoints.md}px) {
    flex-direction: column;

    ${FooterList} li {
      margin: 1rem 1rem 0 0;
    }
  }

  @media (max-width: ${Breakpoints.sm}px) {
    width: 100%;
    ${FooterList} li {
      margin: 0;
      text-align: center;
    }
  }
`;

export const AppFooter = () => {
  return (
    <Footer>
      <FooterInner alignItems="center">
        <Box flex={1}>
          <CoreLink href="/">
            <AppLogo />
          </CoreLink>
        </Box>

        <Box>
          <FooterList>
            <li>
              <CoreLink href="/legals/terms-and-conditions">Terms of Use</CoreLink>
            </li>
            <li>
              <CoreLink href="/legals/privacy-policy">Privacy Policy</CoreLink>
            </li>
            <li>
              <CoreLink href="/legals/disclaimer">Disclaimer</CoreLink>
            </li>

            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://help.heydoctor.com/en/articles/3575049-california-consumer-privacy-act-privacy-notice">
                Collection Notice
              </a>
            </li>

            <li>
              <Link
                to="#"
                onClick={() => {
                  if (window.Osano) {
                    window.Osano.cm.emit('osano-cm-dom-info-dialog-open');
                  }
                }}>
                Cookie Preferences
              </Link>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://support.goodrx.com/hc/en-us/articles/360032961692-Accessibility-on-GoodRx">
                Accessibility
              </a>
            </li>
          </FooterList>
        </Box>
      </FooterInner>
    </Footer>
  );
};
